<template>
  <div id="app" :class="'app--' + $store.state.device">
    <component :is="'header-' + $store.state.device"></component>
    <router-view />
    <component :is="'footer-' + $store.state.device"></component>
    <a-back-top />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { throttle } from 'lodash-es'
import HeaderPc from './components/header-pc.vue'
import HeaderM from './components/header-m.vue'
import FooterPc from './components/footer-pc.vue'
import FooterM from './components/footer-m.vue'

export default {
  components: {
    HeaderPc,
    HeaderM,
    FooterPc,
    FooterM
  },

  created () {
    // resize节流
    this.resizeChange = throttle(this.resizeChange, 200)
    this.resizeChange()
    window.addEventListener('resize', this.resizeChange, false)
  },

  methods: {
    ...mapMutations(['setDevice']),

    resizeChange () {
      // 默认设置当屏幕宽度 > 1000 时，为PC端
      if (document.documentElement.clientWidth > 800) {
        this.setDevice('pc')
      } else {
        // 默认设置当屏幕宽度 <= 1000 时，为移动端
        this.setDevice('m')
      }
    }
  },

  destroyed () {
    window.removeEventListener('resize', this.resizeChange, false)
  }
}
</script>

<style lang="scss" scoped>
.app--pc {
  min-width: $container-width;
}

.app--m {
  width: 100vw;
}
</style>
